var _rect, _circle, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#4B9BF5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 11,
    fill: "#F6F7FB "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1201,
    y: 16.28,
    width: 1.76,
    height: 11.44,
    rx: 0.88,
    fill: "#4B9BF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7202,
    y: 21.12,
    width: 1.76,
    height: 11.44,
    rx: 0.88,
    transform: "rotate(90 27.7202 21.12)",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusActive);
export default __webpack_public_path__ + "static/media/plus-active.17a4535966b126c023ba811ca1a8d3d4.svg";
export { ForwardRef as ReactComponent };